import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { ShieldCheck, Clock } from 'lucide-react';
export const FinalCTA = () => {
  return <section className="py-24 bg-gradient-fuchsia relative overflow-hidden" data-id="element-88">
      <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1616394584738-fc6e612e71b9?auto=format&fit=crop&w=2000&q=80')] opacity-10 bg-cover bg-center mix-blend-overlay" data-id="element-89" />

      <div className="container mx-auto px-6 max-w-4xl relative z-10 text-center" data-id="element-90">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-91">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-white mb-6 leading-tight" data-id="element-92">
            Tu futuro en la estética empieza{' '}
            <span className="italic text-gold-dark" data-id="element-93">HOY</span>
          </h2>

          <p className="text-xl text-white/90 mb-10 max-w-2xl mx-auto" data-id="element-94">
            No dejes pasar esta oportunidad de formarte con el sistema más
            completo y al mejor precio. La oferta termina pronto.
          </p>

          <div className="bg-white p-2 rounded-full inline-block shadow-glow mb-8" data-id="element-95">
            <CTAButton text="QUIERO MI ACCESO AHORA" className="w-full sm:w-auto px-10 py-5 text-lg" data-id="element-96" />
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 text-white/80 text-sm font-medium" data-id="element-97">
            <div className="flex items-center gap-2" data-id="element-98">
              <Clock className="w-5 h-5 text-gold" data-id="element-99" />
              <span data-id="element-100">Acceso Inmediato</span>
            </div>
            <div className="hidden sm:block w-1 h-1 bg-white/30 rounded-full" data-id="element-101" />
            <div className="flex items-center gap-2" data-id="element-102">
              <ShieldCheck className="w-5 h-5 text-gold" data-id="element-103" />
              <span data-id="element-104">Garantía de 7 Días</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
};